import lazyLoading from './lazyLoading'

export default {
  name: 'HomeNet Legal Information',
  path: '/homenet/legalinfo',
  redirect: '/homenet/legalinfo/data',
  meta: {
    auth: ['user'],
    icon: 'fas fa-cube',
    expanded: false
  },
  component: lazyLoading('homenet', true),
  children: [
    {
      'name': 'Data',
      'path': 'data',
      'meta': {
        'label': 'Data'
      },
      'component': lazyLoading('homenet/LegalInfo')
    }
  ]
}



// WEBPACK FOOTER //
// ./client/store/modules/menu/legalInfo.js